module.exports = __webpack_public_path__ + "img/Bil.a6e41e64.png";